"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RealTimeCookiePlug = exports.RealTimeCookie = void 0;

var _classPrivateFieldLooseBase2 = _interopRequireDefault(require("@babel/runtime/helpers/classPrivateFieldLooseBase"));

var _classPrivateFieldLooseKey2 = _interopRequireDefault(require("@babel/runtime/helpers/classPrivateFieldLooseKey"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _emitter2 = require("../emitter");

var RealTimeCookiePlug = /*#__PURE__*/function () {
  function RealTimeCookiePlug() {
    (0, _classCallCheck2.default)(this, RealTimeCookiePlug);
  }

  (0, _createClass2.default)(RealTimeCookiePlug, [{
    key: "addListener",
    value: function addListener() {
      if (process.env.NODE_ENV !== 'test') {
        console.error('RealTimeCookie should not use in server render');
      }
    }
  }, {
    key: "removeListener",
    value: function removeListener() {
      if (process.env.NODE_ENV !== 'test') {
        console.error('RealTimeCookie should not use in server render');
      }
    }
  }]);
  return RealTimeCookiePlug;
}();

exports.RealTimeCookiePlug = RealTimeCookiePlug;

var _emitter = /*#__PURE__*/(0, _classPrivateFieldLooseKey2.default)("emitter");

var _task = /*#__PURE__*/(0, _classPrivateFieldLooseKey2.default)("task");

var RealTimeCookie = /*#__PURE__*/function () {
  function RealTimeCookie(task) {
    var _this = this;

    (0, _classCallCheck2.default)(this, RealTimeCookie);
    Object.defineProperty(this, _emitter, {
      writable: true,
      value: new _emitter2.Emitter()
    });
    Object.defineProperty(this, _task, {
      writable: true,
      value: void 0
    });
    (0, _classPrivateFieldLooseBase2.default)(this, _task)[_task] = task;

    (0, _classPrivateFieldLooseBase2.default)(this, _task)[_task].setTask(function (cookie) {
      return (0, _classPrivateFieldLooseBase2.default)(_this, _emitter)[_emitter].emit(cookie);
    });
  }

  (0, _createClass2.default)(RealTimeCookie, [{
    key: "addListener",
    value: function addListener(f) {
      (0, _classPrivateFieldLooseBase2.default)(this, _emitter)[_emitter].addListener(f);

      (0, _classPrivateFieldLooseBase2.default)(this, _task)[_task].start();
    }
  }, {
    key: "removeListener",
    value: function removeListener(f) {
      (0, _classPrivateFieldLooseBase2.default)(this, _emitter)[_emitter].removeListener(f);

      if (!(0, _classPrivateFieldLooseBase2.default)(this, _emitter)[_emitter].hasSubscribers) {
        (0, _classPrivateFieldLooseBase2.default)(this, _task)[_task].stop();
      }
    }
  }]);
  return RealTimeCookie;
}();

exports.RealTimeCookie = RealTimeCookie;